import { getDocs, collection, query, where } from "@firebase/firestore";
import { hideLoading, setForSaleEssentialsList, showLoading } from "./for-sale-essentials-list-slice";
import { showErrorSnackbar } from "../../../../shared/snackbar/snackbar-slice";

export const getForSaleEssentialsService = async (dispatch, db, coll) => {
    try {
        dispatch(showLoading());
        const querySnapshot = await getDocs(
            query(collection(db, coll), where("type", "==", "For sale"), where("category", "==", "Essential"))
        );
        const data = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
        }));
        dispatch(setForSaleEssentialsList(data));
        dispatch(hideLoading());
    } catch (e) {
        dispatch(showErrorSnackbar('Fetch failed! Please try again.'))
        console.error("ForSaleEssentialsList getForSaleEssentialsService error: ", e);
    }
};